export enum NumericType {
    Currency = 0,
    Number = 1,
    Percent = 2,
    Time = 3,
}

export enum TimeType {
    None = 0,
    Second = 1,
    Minute = 2,
    Hour = 3,
    Time = 4
}

export enum CurrencyType {
    None = 0,
    USD = 1,
    EUR = 2,
    CAD = 3,
    GBP = 4,
    JPY = 5,
    MXN = 6,
    AUD = 7,
    BRL = 8,
    PHP = 9,
    ARS = 10,
    COP = 11,
    ILS = 12,
    SEK = 13,
    CHF = 14
}

export default interface Metric {
    MetricID: number;

    Abbreviation: string;
    DefaultDirection: number;
    MetricDescription: string;
    MetricGroup: string;
    MetricName: string;
    MetricCustomName: string;
    MetricType: number;
    NumericType: NumericType;
    PointMetricType: number;
    TimeType: TimeType;
    CurrencyType: CurrencyType;
    hasPO: boolean;
    ImageID: number;
}

export enum DefaultDirection {
    Down = 0,
    Up = 1
}
